/* template */
<template minapp="mpx" xlang="wxml"><es-popup position="bottom" :closeable="(false)" :show="(visible)"><div class="es-privacy"><div class="es-privacy__header">{{ list.title }}</div><div class="es-privacy__body">{{ list.content }}</div><div class="es-privacy__link"><mpx-view @tap="onLink">{{ list.link_text }}</mpx-view></div><div class="es-privacy__footer"><mpx-view @tap="onCancel" class="es-privacy__button es-privacy__button--disagree">{{ list.disagree_btn_text }}</mpx-view><mpx-view @tap="onConfirm" class="es-privacy__button es-privacy__button--primary">{{ list.agree_btn_text }}</mpx-view></div></div></es-popup></template>

/* styles */
<style scoped mpxStyleOptions='{"mid":"m6f368ef8"}'>
  .es-privacy {
    border-radius: 16px 16px 0 0;
    padding: 0 20px;
    background: #ffffff;
    overflow: hidden;
    box-sizing: border-box;
  }
  .es-privacy__header {
    font-family: PingFangSC-Semibold;
    font-size: 20px;
    color: #000;
    padding: 32px 0 10px 0;
  }
  .es-privacy__body {
    max-height: 120px;
    overflow-y: auto;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666666;
    line-height: 24px;
  }
  .es-privacy__link {
    margin: 18px 0;
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 13px;
    color: #1473ff;
    text-align: center;
    text-decoration: underline;
  }
  .es-privacy__footer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 100rpx;
  }
  .es-privacy__button {
    flex: 1;
    height: 48px;
    line-height: 48px;
    border-radius: 8px;
    text-align: center;
    font-size: 16px;
    box-sizing: border-box;
  }

  .es-privacy__button--disagree {
    border: 1px solid #ccc;
    color: #333;
  }

  .es-privacy__button--primary {
    margin-left: 16rpx;
    border: 1px solid #FF6400;
    background: #FF6400;
    color: #fff;
  }
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m6f368ef8"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex6f368ef8%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex6f368ef8%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m6f368ef8"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index6f368ef8/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-popup':getComponent(require("../../../../../node_modules/@didi/es-mpx-ui/lib/popup/index.mpx?isComponent&outputPath=components%2Findex9216a4d4%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
